export const GET_LICENSE = "GET_LICENSE";
export const GOT_LICENSE = "GOT_LICENSE";

export const GET_UNSAFE_REQUESTS = "GET_UNSAFE_REQUESTS";
export const GOT_UNSAFE_REQUESTS = "GOT_UNSAFE_REQUESTS";

export const GET_TRACE_DETAIL = "GET_TRACE_DETAIL";
export const GOT_TRACE_DETAIL = "GOT_TRACE_DETAIL";

export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";
export const GOT_DASHBOARD_DATA = "GOT_DASHBOARD_DATA";

export const GET_STATS_SUMMARY = "GET_STATS_SUMMARY";
export const GOT_STATS_SUMMARY = "GOT_STATS_SUMMARY";

export const GET_TRACE_RECORDS = "GET_TRACE_RECORDS";
export const GOT_TRACE_RECORDS = "GOT_TRACE_RECORDS";
export const RESET_TRACE_RECORDS = "RESET_TRACE_RECORDS";

export const GET_POLICY_NAME_MAPPING = "GET_POLICY_NAME_MAPPING";
export const GOT_POLICY_NAME_MAPPING = "GOT_POLICY_NAME_MAPPING";
